<template>
  <div class="save-paper">
    <!-- Confirmation Modal Backdrop -->
    <div v-if="!paperSavedInFolderState" class="save-paper__backdrop">
      <div class="save-paper__wrapper">
        <div class="save-paper__modal">
          <div class="save-paper__body">
            <h2 class="save-paper__heading">Are you sure you want to save this paper?</h2>

            <!-- Loading Spinner -->
            <div v-if="isSubmitted" class="save-paper__loader">
              <img
                src="@/assets/images/progressbar.gif"
                class="save-paper__loader-img"
                alt="Saving paper..."
                width="50"
              />
            </div>

            <!-- Action Buttons -->
            <div class="save-paper__actions">
              <button
                type="button"
                class="save-paper__btn save-paper__btn--danger"
                :disabled="isSubmitted"
                @click="closeSavePaperPopupMethod"
              >
                Decline
              </button>

              <button
                type="button"
                class="save-paper__btn save-paper__btn--success"
                :disabled="isSubmitted"
                @click="savePaperBeforeSubmitMethod"
              >
                Yes, I want
              </button>

              <!-- <button
                type="button"
                class="save-paper__btn save-paper__btn--primary"
                :disabled="isSubmitted"
                @click="savePaperinFolderBeforeSubmitMethod"
              >
                Save in folder
              </button> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Folder Upload View -->
    <paper-upload-in-new-folder
      v-if="paperSavedInFolderState"
      :paper-id="paperId"
    ></paper-upload-in-new-folder>
  </div>
</template>

<script>
import axios from 'axios';
import { bus } from '@/main';
import PaperUploadInNewFolder from '../paper-upload-in-folder';
import root from '@/_helpers/roots';
import toast from '@/services/toast';

const savedQuerySearchPaperApiUrl = root.savedQuerySearchPaperApiUrl.link;

export default {
  name: 'SavePaperInfo',
  components: {
    'paper-upload-in-new-folder': PaperUploadInNewFolder
  },
  props: {
    paperInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isSubmitted: false,
      paperId: '',
      paperSavedInFolderState: false
    };
  },
  mounted() {
    bus.$on('paperSavedInFolderStateBus', (data) => {
      this.paperSavedInFolderState = data;
    });
  },
  beforeDestroy() {
    bus.$off('paperSavedInFolderStateBus');
  },
  methods: {
    getPaperPileListAgain() {
      this.$store.dispatch('getAllPaperPileFun');
    },

    async savePaperinFolderBeforeSubmitMethod() {
      this.isSubmitted = true;
      try {
        const res = await axios.post(savedQuerySearchPaperApiUrl, this.paperInfo);
        const result = res.data && res.data.data && res.data.data.result;

        if (result && result.message) {
          toast.success(result.message);
        } else if (result && result.id) {
          this.paperId = result.id;
          toast.success('Request processed successfully.');
          this.paperSavedInFolderState = true;
        }

        this.getPaperPileListAgain();
      } catch (err) {
        toast.error('Request Failed');
      } finally {
        this.isSubmitted = false;
      }
    },

    async savePaperBeforeSubmitMethod() {
      this.isSubmitted = true;
      try {
        const res = await axios.post(savedQuerySearchPaperApiUrl, this.paperInfo);
        const result = res.data && res.data.data && res.data.data.result;
        const msg = (result && result.message) || 'Request processed successfully.';
        toast.success(msg);

        this.getPaperPileListAgain();
        this.$router.push({ name: 'paperPiles' });
        this.closeAllPopupMethod();
      } catch (err) {
        toast.error('Request Failed');
      } finally {
        this.isSubmitted = false;
      }
    },

    closeAllPopupMethod() {
      bus.$emit('savePaperPopupStateBus', false);
      bus.$emit('addPaperPilePopupStateBus', false);
      bus.$emit('uploadPaperStateBus', false);
      document.body.classList.remove('body_right_scroll_remove');
    },

    closeSavePaperPopupMethod() {
      document.body.classList.remove('body_right_scroll_remove');
      bus.$emit('savePaperPopupStateBus', false);
    }
  }
};
</script>

<style lang="scss" scoped>
$font-stack: 'MyriadProRegular', 'Lato', sans-serif;
$theme-gold: #ffd400;
$btn-hover-gold: #ffe738;
$bg-backdrop: rgba(0, 0, 0, 0.92);
$text-light: #ffffff;
$btn-danger: rgba(255, 18, 18, 0.5);
$btn-success: rgba(33, 228, 0, 0.5);
$btn-primary: rgba(5, 170, 197, 0.5);

.save-paper {
  font-family: $font-stack;

  // Backdrop overlay
  &__backdrop {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1000;
    background: $bg-backdrop;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 15px;
  }

  &__wrapper {
    width: 100%;
    max-width: 560px;
    max-height: 100dvh;
    overflow-y: auto;
  }

  &__modal {
    background: #000000;
    border-radius: 8px;
    box-shadow: 0 0 16px rgba(255, 213, 0, 0.5);
    padding: 30px 20px;
    border: 1px solid rgba(255, 213, 0, 0.2);
  }

  &__body {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  &__heading {
    font-size: 1.25rem;
    color: $text-light;
    margin: 0 0 24px;
    font-weight: 500;
    line-height: 1.4;
  }

  &__loader {
    margin-bottom: 20px;
  }

  &__loader-img {
    display: inline-block;
  }

  &__actions {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 12px;
    width: 100%;
  }

  &__btn {
    min-width: 110px;
    padding: 8px 16px;
    border: none;
    border-radius: 4px;
    font-size: 0.95rem;
    font-weight: normal;
    font-family: inherit;
    color: $text-light;
    cursor: pointer;
    transition: background 0.2s ease, color 0.2s ease, opacity 0.2s ease;

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

    &:hover:not(:disabled) {
      background: $btn-hover-gold;
      color: #22292f;
    }

    &--danger {
      background: $btn-danger;
    }

    &--success {
      background: $btn-success;
    }

    &--primary {
      background: $btn-primary;
    }

    @media (max-width: 576px) {
      min-width: 80px;
      font-size: 0.85rem;
      padding: 6px 12px;
      flex: 1 1 calc(50% - 12px);
    }
  }
}
</style>